"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3574],{

/***/ 62204:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function SvgGreenCheck(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M9.295 15.875l-4.17-4.17-1.42 1.41 5.59 5.59 12-12-1.41-1.41-10.59 10.58z",
    fill: "#7D8F5C"
  })));
}
/* harmony default export */ __webpack_exports__["Z"] = (SvgGreenCheck);

/***/ }),

/***/ 52217:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ EmbeddedFunnel_EmbeddedQuestion; }
});

// UNUSED EXPORTS: defaultStepTitleMapping

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@heycater/design-system/dist/esm/index.js + 12 modules
var esm = __webpack_require__(95197);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js
var useTranslation = __webpack_require__(26793);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(57833);
// EXTERNAL MODULE: ./src/qualification/components/question_types/BudgetQuestionWithPeopleCount/index.tsx + 2 modules
var BudgetQuestionWithPeopleCount = __webpack_require__(8464);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/add/index.js
var add = __webpack_require__(29422);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/format/index.js + 18 modules
var format = __webpack_require__(46216);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/isFirstDayOfMonth/index.js
var isFirstDayOfMonth = __webpack_require__(44812);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/isSameMonth/index.js
var isSameMonth = __webpack_require__(49160);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/getWeek/index.js + 2 modules
var getWeek = __webpack_require__(13956);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/addWeeks/index.js
var addWeeks = __webpack_require__(63500);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-day-picker/dist/index.esm.js + 28 modules
var index_esm = __webpack_require__(4617);
// EXTERNAL MODULE: ./node_modules/react-day-picker/dist/style.css
var style = __webpack_require__(19034);
// EXTERNAL MODULE: ./src/qualification/components/question_types/DatePicker/DatePickerLayout.tsx
var DatePickerLayout = __webpack_require__(53466);
// EXTERNAL MODULE: ./src/qualification/components/question_types/DatePicker/DatePickerSide.tsx + 1 modules
var DatePickerSide = __webpack_require__(23922);
// EXTERNAL MODULE: ./src/qualification/context/index.tsx + 11 modules
var context = __webpack_require__(85643);
// EXTERNAL MODULE: ./src/qualification/schema/questions/eventDateQuestion.ts
var eventDateQuestion = __webpack_require__(85785);
// EXTERNAL MODULE: ./src/shared/helpers/dates.js
var dates = __webpack_require__(47004);
;// CONCATENATED MODULE: ./src/qualification/components/question_types/DatePicker/DatePickerEmbedded.tsx



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: transparent;\n  border: none;\n  cursor: pointer;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: #686d6b;\n  font-size: 12px;\n  line-height: 17px;\n  letter-spacing: 0.4px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 400px;\n  max-width: 100%;\n  margin: ",
        ";\n  margin: 0 auto;\n  padding: 0;\n  .rdp {\n    --rdp-accent-color: ",
        ";\n    --rdp-background-color: #a3cb1861;\n    --rdp-cell-size: 35px;\n\n    background-color: white;\n    border-radius: 8px;\n    padding: ",
        ";\n    margin: 0 auto;\n  }\n\n  .rdp-head_cell {\n    font-size: 14px;\n    font-weight: 400;\n    padding-bottom: ",
        "px;\n    padding-top: ",
        "px;\n  }\n\n  .rdp-button {\n    transition: background-color 0.2s ease;\n  }\n\n  .rdp-day_outside {\n    opacity: 0.8;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: fit-content;\n  margin: 0 auto;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}













var defaultLeadTimeInDays = eventDateQuestion/* DEFAULT_LEAD_DAYS */.n0;
function DatePickerEmbedded() {
    var ref, ref1;
    var router = (0,next_router.useRouter)();
    var ref2 = (0,context/* useQualification */._8)(), answerOf = ref2.answerOf, actions = ref2.actions, state = ref2.state;
    var answer = answerOf("event_date");
    var date = answer;
    var activeDate = date ? new Date(date) : undefined;
    var minimumDate = (0,add/* default */.Z)(new Date(), {
        days: defaultLeadTimeInDays
    });
    var attributes = "qualification" in state ? eventDateQuestion/* dateQuestion.getAttributes */.uO.getAttributes({
        answers: state.qualification.answers,
        selectedCaterer: state.qualification.selectedCaterer
    }) : null;
    var minDateMessage = router.locale === "en" ? attributes === null || attributes === void 0 ? void 0 : (ref = attributes.minDate) === null || ref === void 0 ? void 0 : ref.messageEn : attributes === null || attributes === void 0 ? void 0 : (ref1 = attributes.minDate) === null || ref1 === void 0 ? void 0 : ref1.messageDe;
    var ref3 = (0,react.useState)(!!answerOf(eventDateQuestion/* isRecurringQuestion.id */.cB.id)), isRecurringNeedSelected = ref3[0];
    (0,react.useEffect)(function() {
        if (date) {
            actions.answerQuestion("has_recurring_need", isRecurringNeedSelected);
        }
    }, [
        isRecurringNeedSelected
    ]);
    var ref4 = (0,react.useState)(activeDate || minimumDate), month = ref4[0], setMonth = ref4[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DatePickerLayout/* default */.Z, {
        dateSelector: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledDateSelect, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(DateSelectWrapper, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* DayPicker */._W, {
                        components: {
                            Caption: CustomCaption,
                            Row: OnlyAfterToday,
                            Day: DayWithOutsideMonthLabel
                        },
                        formatters: {
                            formatWeekdayName: function(day, options) {
                                return (0,format/* default */.Z)(day, "EEEEE", {
                                    locale: options === null || options === void 0 ? void 0 : options.locale
                                });
                            }
                        },
                        month: month,
                        onDayClick: function(date) {
                            return actions.answerQuestion("event_date", date);
                        },
                        selected: activeDate,
                        fromDate: minimumDate,
                        onMonthChange: setMonth,
                        captionLayout: "buttons",
                        locale: router.locale ? dates/* localeToDateLocaleMapping */.Eb[router.locale] : undefined,
                        showOutsideDays: true,
                        mode: "single"
                    })
                }),
                minDateMessage && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                    textAlign: "center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TypographyCaption, {
                        children: [
                            "*",
                            minDateMessage
                        ]
                    })
                })
            ]
        }),
        sideContent: /*#__PURE__*/ (0,jsx_runtime.jsx)(DatePickerSide/* default */.Z, {})
    });
}
function DayWithOutsideMonthLabel(props) {
    var outside = (0,index_esm/* useActiveModifiers */.JM)(props.date, props.displayMonth).outside;
    var daypicker = (0,index_esm/* useDayPicker */.kD)();
    if (outside && (0,isFirstDayOfMonth/* default */.Z)(props.date)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Box, {
            position: "relative",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                    position: "absolute",
                    top: "-3px",
                    left: "-3px",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Typography, {
                        fontSize: 9,
                        children: (0,format/* default */.Z)(props.date, "MMM", {
                            locale: daypicker.locale
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Day */.Jc, (0,_object_spread/* default */.Z)({}, props))
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Day */.Jc, (0,_object_spread/* default */.Z)({}, props));
}
function CustomCaption(props) {
    var ref = (0,index_esm/* useNavigation */.HJ)(), goToMonth = ref.goToMonth, nextMonth = ref.nextMonth, previousMonth = ref.previousMonth;
    var daypicker = (0,index_esm/* useDayPicker */.kD)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Box, {
        display: "flex",
        justifyContent: "space-between",
        py: 1,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MonthNavigationButton, {
                type: "button",
                disabled: !previousMonth,
                onClick: function() {
                    return previousMonth && goToMonth(previousMonth);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* IconLeft */.hf, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Typography, {
                fontSize: 14,
                children: (0,format/* default */.Z)(props.displayMonth, "MMMM", {
                    locale: daypicker.locale
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MonthNavigationButton, {
                type: "button",
                disabled: !nextMonth,
                onClick: function() {
                    return nextMonth && goToMonth(nextMonth);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* IconRight */.Jp, {})
            })
        ]
    });
}
function OnlyAfterToday(props) {
    var today = new Date();
    var isFirstMonth = (0,isSameMonth/* default */.Z)(today, props.displayMonth);
    if (isFirstMonth) {
        /**
     * Offset the first month, so the fromDate is shown in the first row
     */ var firstWeekOfMonth = (0,getWeek/* default */.Z)(props.displayMonth);
        var weekOfFirstSelectableDay = (0,getWeek/* default */.Z)(today);
        var weekOffset = weekOfFirstSelectableDay - firstWeekOfMonth;
        var datesWithWeekOffset = props.dates.map(function(date) {
            return (0,addWeeks/* default */.Z)(date, weekOffset);
        });
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Row */.X2, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
            weekNumber: props.weekNumber + weekOffset,
            dates: datesWithWeekOffset
        }));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Row */.X2, (0,_object_spread/* default */.Z)({}, props));
}
var MonthNavigationButton = styled_components_browser_esm["default"].button(_templateObject());
var TypographyCaption = (0,styled_components_browser_esm["default"])(esm.Typography)(_templateObject1());
var StyledDateSelect = styled_components_browser_esm["default"].div(_templateObject2(), function(props) {
    return props.theme.spacing(2, "auto", 3, "auto");
}, function(param) {
    var theme = param.theme;
    return theme.palette.secondary.light;
}, function(param) {
    var theme = param.theme;
    return theme.spacing(1.5, 2, 2, 2);
}, function(param) {
    var theme = param.theme;
    return theme.spacing(2);
}, function(param) {
    var theme = param.theme;
    return theme.spacing(2.5);
});
var DateSelectWrapper = styled_components_browser_esm["default"].div(_templateObject3());
/* harmony default export */ var DatePicker_DatePickerEmbedded = (DatePickerEmbedded);

// EXTERNAL MODULE: ./src/qualification/components/question_types/DietaryDistribution.tsx + 1 modules
var DietaryDistribution = __webpack_require__(68106);
// EXTERNAL MODULE: ./src/qualification/schema/questions/index.ts
var questions = __webpack_require__(89121);
// EXTERNAL MODULE: ./src/qualification/schema/steps/index.ts
var steps = __webpack_require__(82546);
// EXTERNAL MODULE: ./src/shared/components/EmbeddedFunnel/EmbeddedQuestionLayout.tsx + 1 modules
var EmbeddedQuestionLayout = __webpack_require__(11156);
// EXTERNAL MODULE: ./src/shared/components/EmbeddedFunnel/experiments/customer_tier/CustomerTier.js + 1 modules
var CustomerTier = __webpack_require__(35269);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./public/artifacts/icons/close-circle.svg
var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function SvgCloseCircle(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M2 12C2 6.47 6.47 2 12 2s10 4.47 10 10-4.47 10-10 10S2 17.53 2 12zm13.59 5L17 15.59 13.41 12 17 8.41 15.59 7 12 10.59 8.41 7 7 8.41 10.59 12 7 15.59 8.41 17 12 13.41 15.59 17z"
  })));
}
/* harmony default export */ var close_circle = (SvgCloseCircle);
// EXTERNAL MODULE: ./public/artifacts/icons/green-check.svg
var green_check = __webpack_require__(62204);
// EXTERNAL MODULE: ./src/qualification/hooks/useBreakpoints.ts
var useBreakpoints = __webpack_require__(19916);
;// CONCATENATED MODULE: ./src/shared/components/SelectedMenu/index.tsx

function SelectedMenu_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 17px;\n"
    ]);
    SelectedMenu_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SelectedMenu_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 172.5%; /* 27.6px */\n"
    ]);
    SelectedMenu_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SelectedMenu_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: none;\n  outline: none;\n  padding: 0;\n  cursor: pointer;\n  background-color: transparent;\n  position: relative;\n  ::before {\n    content: '';\n    position: absolute;\n    left: 3px;\n    top: 3px;\n    height: 18px;\n    width: 18px;\n    border-radius: 100px;\n    z-index: -1;\n    background-color: rgba(0, 0, 0, 0.5);\n  }\n"
    ]);
    SelectedMenu_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function SelectedMenu_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 10px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 17px;\n  letter-spacing: 0.4px;\n"
    ]);
    SelectedMenu_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  width: 100%;\n  height: 1px;\n  background-color: rgba(0, 0, 0, 0.1);\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: ",
        ";\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-shrink: none;\n  width: 100%;\n  border: 1px solid ",
        ";\n  background-color: #f7fcfa;\n  box-shadow: 0px 4px 20px 0px rgba(62, 41, 29, 0.08);\n  position: relative;\n  display: flex;\n  height: 100%;\n  flex-shrink: 0;\n  flex-direction: column;\n  border-radius: ",
        "px;\n  overflow: hidden;\n  box-shadow: 0px 4px 20px 0px rgba(62, 41, 29, 0.08);\n\n  ",
        " {\n    width: 300px;\n    border-radius: ",
        "px;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  z-index: 2;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: #3c4340;\n  padding: 0;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 150%; /* 27px */\n\n  ",
        " {\n    font-size: 18px;\n    text-align: center;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}










var SelectedMenuCard = function(props) {
    var actions = (0,context/* useQualification */._8)().actions;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var isMobile = (0,useBreakpoints/* useBreakpointDown */.a)("sm");
    if (isMobile) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseButtonWrapper, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseButton, {
                        onClick: actions.clearBestseller,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(close_circle, {})
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Box, {
                    display: "flex",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                            display: "flex",
                            flexShrink: 0,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                alt: "",
                                src: props.imageSrc,
                                height: 70,
                                width: 70,
                                quality: 100,
                                objectFit: "cover"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Box, {
                            display: "flex",
                            mx: 2,
                            textAlign: "start",
                            flexDirection: "column",
                            alignItems: "flex-start",
                            justifyContent: "center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CardLabel, {
                                    children: t("qualification:bestseller.labelShort")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                                    children: props.title
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                py: 2,
                pb: 1,
                textAlign: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardLabel, {
                    children: t("qualification:bestseller.label")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseButtonWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseButton, {
                            onClick: actions.clearBestseller,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(close_circle, {})
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                        mb: 2,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            alt: "",
                            src: props.imageSrc,
                            height: 142,
                            width: 300,
                            objectFit: "cover"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContent, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                                mb: 1,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                                    children: props.title
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                                as: "ul",
                                p: 0,
                                m: 0,
                                mb: 2,
                                children: props.contents.map(function(benefit) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Box, {
                                        as: "li",
                                        display: "flex",
                                        alignItems: "flex-start",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                                                mr: 1,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(green_check/* default */.Z, {})
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                                                mb: 1,
                                                children: benefit
                                            })
                                        ]
                                    }, benefit);
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                                mt: "auto",
                                mb: 1,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Box, {
                                textAlign: "center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(PriceRange, {
                                        children: [
                                            props.priceRange[0],
                                            " - ",
                                            props.priceRange[1],
                                            " € p.P."
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceRangeLabel, {
                                        children: t("qualification:bestseller.delivery")
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var SelectedMenu = (SelectedMenuCard);
var CardLabel = (0,styled_components_browser_esm["default"])(esm.Typography)(SelectedMenu_templateObject(), function(param) {
    var theme = param.theme;
    return theme.palette.secondary[500];
});
var PriceRange = styled_components_browser_esm["default"].div(SelectedMenu_templateObject1());
var CloseButton = styled_components_browser_esm["default"].button(SelectedMenu_templateObject2());
var PriceRangeLabel = styled_components_browser_esm["default"].div(SelectedMenu_templateObject3());
var Divider = styled_components_browser_esm["default"].div(_templateObject4());
var CardContent = styled_components_browser_esm["default"].div(_templateObject5(), function(param) {
    var theme = param.theme;
    return theme.spacing(0, 2, 2, 2);
});
var Card = styled_components_browser_esm["default"].div(_templateObject6(), function(param) {
    var theme = param.theme;
    return theme.palette.secondary[500];
}, function(param) {
    var theme = param.theme;
    return theme.spacing(0.8);
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("md");
}, function(param) {
    var theme = param.theme;
    return theme.spacing(1.5);
});
var CloseButtonWrapper = styled_components_browser_esm["default"].div(_templateObject7());
var Title = (0,styled_components_browser_esm["default"])(esm.Typography)(_templateObject8(), function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("md");
});

;// CONCATENATED MODULE: ./src/shared/components/EmbeddedFunnel/experiments/customer_tier/EmbeddedCustomerTier.js








function EmbeddedCustomerTier(param) {
    var ratings = param.ratings, slides = param.slides, LayoutComponent = param.LayoutComponent;
    var ref, ref1, ref2;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var state = (0,context/* useQualification */._8)().state;
    var selectedMenu = "qualification" in state ? state.qualification.selectedMenu : null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
        mx: (slides === null || slides === void 0 ? void 0 : (ref = slides.tier) === null || ref === void 0 ? void 0 : ref.whiteWrapper) && 2,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LayoutComponent, {
            wrapper: (slides === null || slides === void 0 ? void 0 : (ref1 = slides.customerTier) === null || ref1 === void 0 ? void 0 : ref1.whiteWrapper) ? "white" : "transparent",
            ratings: ratings,
            disableGutters: true,
            bgcolor: (slides === null || slides === void 0 ? void 0 : (ref2 = slides.tier) === null || ref2 === void 0 ? void 0 : ref2.whiteWrapper) ? "white" : "transparent",
            containerSize: 1150,
            answerContainerSize: 1150,
            borderRadius: "8px",
            title: t("qualification:customerTier.title"),
            side: selectedMenu && /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectedMenu, (0,_object_spread/* default */.Z)({}, selectedMenu)),
            content: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomerTier/* default */.Z, {})
        })
    });
}

// EXTERNAL MODULE: ./src/lib/ablyft/index.ts
var ablyft = __webpack_require__(49423);
// EXTERNAL MODULE: ./src/shared/components/EmbeddedFunnel/experiments/rare_tier/CustomerRareTier.js + 2 modules
var CustomerRareTier = __webpack_require__(61692);
;// CONCATENATED MODULE: ./src/shared/components/EmbeddedFunnel/experiments/rare_tier/EmbeddedCustomerRareTier.js









function CustomerTierRare(param) {
    var ratings = param.ratings, slides = param.slides, LayoutComponent = param.LayoutComponent;
    var ref, ref1, ref2;
    var state = (0,context/* useQualification */._8)().state;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var selectedMenu = "qualification" in state ? state.qualification.selectedMenu : null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
        mx: (slides === null || slides === void 0 ? void 0 : (ref = slides.tier) === null || ref === void 0 ? void 0 : ref.whiteWrapper) && 2,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LayoutComponent, {
            wrapper: (slides === null || slides === void 0 ? void 0 : (ref1 = slides.customerTier) === null || ref1 === void 0 ? void 0 : ref1.whiteWrapper) ? "white" : "transparent",
            ratings: ratings,
            disableGutters: true,
            bgcolor: (slides === null || slides === void 0 ? void 0 : (ref2 = slides.tier) === null || ref2 === void 0 ? void 0 : ref2.whiteWrapper) ? "white" : "transparent",
            containerSize: 1150,
            answerContainerSize: 800,
            borderRadius: "8px",
            title: (0,ablyft/* isVariationActive */.s_)(ablyft/* EXPERIMENT.customerTierABC.variations.variationB */.Op.customerTierABC.variations.variationB) ? t("qualification:rareCustomerTier.v1.title") : null,
            side: selectedMenu && /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectedMenu, (0,_object_spread/* default */.Z)({}, selectedMenu)),
            content: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomerRareTier/* default */.Z, {})
        })
    });
}

;// CONCATENATED MODULE: ./public/artifacts/images/shared/catering_category/tile_icons/bbq.webp
/* harmony default export */ var bbq = ({"src":"/_next/static/media/bbq.3da6ffe6.webp","height":230,"width":230,"blurDataURL":"data:image/webp;base64,UklGRpQAAABXRUJQVlA4WAoAAAAQAAAABwAABwAAQUxQSDgAAAABYBTbVptH9cEaK6wwQWKAiaRupK960dITDRExAfjpyjIgQHgcx1EodI/dmuHRQ8cPD0g/LxHFN1ZQOCA2AAAA0AEAnQEqCAAIAAJAOCWkAAL3hl2aTgAA/vv1ok6l9gxeMmXwiTcad0g99PjpT8qhtokMAAAA","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/artifacts/images/shared/catering_category/tile_icons/breakfast.webp
/* harmony default export */ var breakfast = ({"src":"/_next/static/media/breakfast.43a18461.webp","height":182,"width":182,"blurDataURL":"data:image/webp;base64,UklGRr4AAABXRUJQVlA4WAoAAAAQAAAABwAABwAAQUxQSDwAAAABYBvZVqpXC5AztKwZKRm9WMQQyneXHiJCbdoGjD2lXAKY+yQxoHKe51mZOj+6/GX9o3/he2kMiKmDpQBWUDggXAAAAPABAJ0BKggACAACQDgloAJ0AR6B+VMtAAD+ijylk8CfrjNq9iA3jYOPt3gPfPkedmnQ2YyPxgSaZPGRo583D3ykde3OH1QLNGPnhnO/uOoKRe3T+RGY78ceyAAA","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/artifacts/images/shared/catering_category/tile_icons/buffet.webp
/* harmony default export */ var buffet = ({"src":"/_next/static/media/buffet.e2947022.webp","height":172,"width":172,"blurDataURL":"data:image/webp;base64,UklGRsgAAABXRUJQVlA4WAoAAAAQAAAABwAABwAAQUxQSEEAAAABYFNr25IP1wRsNlOLBuyMbASgg+wU4JDAV3cC/EaIiJgA8LLvKWzwN4QQmqwU/SbdXz3+3fFfaFZMKYMSNXkgAQBWUDggYAAAAJACAJ0BKggACAACQDgloAJ0ugAOEB+oBmVaM8sAAP5m3qx2/p7ON5zGnAdCTniVQ20JvSQES+N4jsqHRIlmF1lyYIDBBlckcIPX6n2mkCPES8X+1U0dc97QJJCnvrYAAA==","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/artifacts/images/shared/catering_category/tile_icons/cake.webp
/* harmony default export */ var cake = ({"src":"/_next/static/media/cake.9ca77a63.webp","height":192,"width":192,"blurDataURL":"data:image/webp;base64,UklGRrQAAABXRUJQVlA4WAoAAAAQAAAABwAABwAAQUxQSD4AAAABYFpr25LvP3/FYS6tZHYg010HoFnkEBnCmebXISJiAgDH+5EagBZCCPmdkEjrSfYNsteVZWgUThNQtG6JAlZQOCBQAAAAsAEAnQEqCAAIAAJAOCUAToAeb1kcAAD+5vIu8On6ccg+e1mZ+L/HmP/ePwJ1CjptZDck2tMsyjsZEg5YLEovdLRdR2639NuBG1lNaLA8AAA=","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/artifacts/images/shared/catering_category/tile_icons/christmas.webp
/* harmony default export */ var christmas = ({"src":"/_next/static/media/christmas.d06c61d8.webp","height":1809,"width":1920,"blurDataURL":"data:image/webp;base64,UklGRsYAAABXRUJQVlA4WAoAAAAQAAAABwAABwAAQUxQSEEAAAAAAAAld3clAAAAU/n///lUAAzv/////+8NRf///////0ZG////////Rg3v/////+8NAFT5///5VAAAACZ4eCYAAABWUDggXgAAAFACAJ0BKggACAACQDgljAJ0fwBpAB48Tj/D8AD+5uV3wJEBKxBLWKPJgiLCPPTcSPqbmQtv3wfZBmbO2MWhytzOYRI4aXlKvEPPd5K00rNFgTYG+XhxywjxADgAAAA=","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/artifacts/images/shared/catering_category/tile_icons/dinner.webp
/* harmony default export */ var dinner = ({"src":"/_next/static/media/dinner.d97ae065.webp","height":110,"width":110,"blurDataURL":"data:image/webp;base64,UklGRqIAAABXRUJQVlA4WAoAAAAQAAAABwAABwAAQUxQSCsAAAABUNBGknIeSPaTNiYt/B4iYgKAlA+GAducc3ZW82n9K/70y1G/hgCZGC0DAFZQOCBQAAAAMAIAnQEqCAAIAAJAOCWUAnRtfwLFwCgzJgAA/vfYJqW+WEtx348iwKl3h/hUA/LGQjDHo49s/EUioAz5YRpXfwdqQbEUq1qleg2mVlvIAAA=","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/artifacts/images/shared/catering_category/tile_icons/drinks.webp
/* harmony default export */ var drinks = ({"src":"/_next/static/media/drinks.f566e7ea.webp","height":110,"width":110,"blurDataURL":"data:image/webp;base64,UklGRsQAAABXRUJQVlA4WAoAAAAQAAAABwAABwAAQUxQSEEAAAAAElGLMAAAAAA+s76YAAYUAEvZ5PDX3bsDlP////nY0Hux////bfn/t7D///9A3f+TsP///1TF/3lDrsyewa+TMgBWUDggXAAAADACAJ0BKggACAACQDglkAJ0BigHZeFco+gAAPa/hV/fU+zUiqQzXA3uNpAKvQ+9IYdm3XnT/rtheicdclm3IOfNOLS+YyKtzqcZVeywPrJ5XQMeasKS2xhe0gAA","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/artifacts/images/shared/catering_category/tile_icons/fingerfood.webp
/* harmony default export */ var fingerfood = ({"src":"/_next/static/media/fingerfood.ae316892.webp","height":168,"width":168,"blurDataURL":"data:image/webp;base64,UklGRq4AAABXRUJQVlA4WAoAAAAQAAAABwAABwAAQUxQSDMAAAABL0AQQBJWhvMu8BoREbwzUBBJaqsozcAxg4A0BwhIUQAR/Y+zoxl8BRfoAl3BDf7Z0QAAVlA4IFQAAAAwAgCdASoIAAgAAkA4JQBOja/hiABpghx4AAD2udJoQL6R/OUqXM+5SYSijPb798d/oj2lJvpwIdktYypJgFMGqLcigoeUdswVVZ5j3FDLk1gAAAA=","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/artifacts/images/shared/catering_category/tile_icons/lunch.webp
/* harmony default export */ var lunch = ({"src":"/_next/static/media/lunch.4f9a2dcd.webp","height":176,"width":170,"blurDataURL":"data:image/webp;base64,UklGRtAAAABXRUJQVlA4WAoAAAAQAAAABwAABwAAQUxQSEEAAAAAAAA/h61GAQADrP////+tBXD///////+Bzv///////+jU////////+Yn////////DEdv/////+T0AFZ3t+ME8AABWUDggaAAAANABAJ0BKggACAACQDglqAJ0ARd7hmQcAMtMZ8dWZa5JrN+D+59WqRZdl/1Yqqj5g0bag8zP62kms54rFA6Zh+BPIdE6WNS/IfnPAq73FKobVyi28vx9HPhdhqZyaGa+VuL5//JsgAAA","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/artifacts/images/shared/catering_category/tile_icons/tacos.webp
/* harmony default export */ var tacos = ({"src":"/_next/static/media/tacos.449c1597.webp","height":198,"width":198,"blurDataURL":"data:image/webp;base64,UklGRsgAAABXRUJQVlA4WAoAAAAQAAAABwAABwAAQUxQSEEAAAAAAAASVFUSAAAASvD///FLABLw//////ESVf///////1VV////////VhLx//////ETAGL8///xTAAAABNWVhMAAABWUDggYAAAADACAJ0BKggACAACQDglqAJ0Bpc8BeltLyUAAP4LI2t7t5icFW/n/4Jj1sZCvILR/Gkhy8nd1zpdVFVFU7YtPUuKECqAn5Go5i/3NtaHphFvJC4FwyupRAFrL2KSUQAAAA==","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./src/shared/components/Tiles/BaseComponents.tsx


function BaseComponents_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  height: auto;\n  gap: ",
        "px;\n  flex-wrap: wrap;\n  justify-content: center;\n\n  ",
        " {\n    width: 930px;\n    flex-direction: row;\n    height: auto;\n    gap: ",
        "px;\n    flex-wrap: wrap;\n    justify-content: center;\n  }\n"
    ]);
    BaseComponents_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function BaseComponents_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      --active-background: #fff9f4;\n      --active-outline: 3px solid ",
        ";\n      --active-text-color: rgba(0, 0, 0, 0.7);\n    "
    ]);
    BaseComponents_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function BaseComponents_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      --active-background: white;\n      --active-outline: 2px solid ",
        ";\n      --active-text-color: ",
        ";\n    "
    ]);
    BaseComponents_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function BaseComponents_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n\n  ",
        "\n \n  --active-shadow: 0px 6px 25px 0px rgba(0, 0, 0, 0.15);\n\n  cursor: pointer;\n  background: #fff;\n  display: flex;\n  overflow: hidden;\n  align-items: center;\n  cursor: pointer;\n  padding: ",
        ";\n  border-radius: 20px;\n  box-shadow: 0px 4px 14px 0px rgba(0, 0, 0, 0.1);\n  gap: ",
        "px;\n  height: 110px;\n  width: 110px;\n  justify-content: flex-start;\n\n  justify-content: center;\n  flex-direction: column;\n  gap: ",
        "px;\n\n  padding: ",
        ";\n\n  ",
        " {\n    justify-content: center;\n    flex-direction: column;\n    gap: ",
        "px;\n    width: 154px;\n    height: ",
        ";\n\n    padding: ",
        ";\n  }\n\n  outline: ",
        ";\n  box-shadow: ",
        ";\n  color: ",
        ";\n  background-color: ",
        ";\n\n  transition: all 0.1s ease;\n\n  @media (hover: hover) {\n    &:hover {\n      outline: var(--active-outline);\n      box-shadow: var(--active-shadow);\n      color: var(--active-color);\n    }\n  }\n\n  :focus,\n  :active {\n    outline: var(--active-outline);\n    box-shadow: var(--active-shadow);\n    color: var(--active-text-color);\n    background-color: var(--active-background);\n  }\n"
    ]);
    BaseComponents_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}




var TilesWrapper = (0,styled_components_browser_esm["default"])(esm.Box)(BaseComponents_templateObject(), function(param) {
    var theme = param.theme;
    return theme.spacing(1);
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("sm");
}, function(param) {
    var theme = param.theme, $size = param.$size;
    return $size === "sm" ? theme.spacing(1) : theme.spacing(2);
});
var TileTypography = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Typography, (0,_object_spread/* default */.Z)({
        fontSize: {
            xs: 12,
            sm: 16
        },
        fontWeight: 600,
        lineHeight: "172.5%"
    }, props));
};
var Tile = styled_components_browser_esm["default"].div(BaseComponents_templateObject3(), function(param) {
    var theme = param.theme, $variant = param.$variant;
    return $variant === "primary" && (0,styled_components_browser_esm.css)(BaseComponents_templateObject1(), theme.palette.primary.main);
}, function(param) {
    var theme = param.theme, $variant = param.$variant;
    return $variant === "secondary" && (0,styled_components_browser_esm.css)(BaseComponents_templateObject2(), theme.palette.secondary[500], theme.palette.secondary[500]);
}, function(param) {
    var theme = param.theme;
    return theme.spacing(2, 2);
}, function(param) {
    var theme = param.theme;
    return theme.spacing(3);
}, function(param) {
    var theme = param.theme;
    return theme.spacing(2);
}, function(param) {
    var theme = param.theme;
    return theme.spacing(3, 1, 2, 1);
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("sm");
}, function(param) {
    var theme = param.theme;
    return theme.spacing(1);
}, function(param) {
    var $height = param.$height;
    return $height || "166px";
}, function(param) {
    var theme = param.theme;
    return theme.spacing(3, 1, 2, 1);
}, function(param) {
    var $selected = param.$selected;
    return $selected ? "var(--active-outline)" : "none";
}, function(param) {
    var $selected = param.$selected;
    return $selected ? "var(--active-shadow)" : "0px 4px 14px 0px rgba(0, 0, 0, 0.1)";
}, function(param) {
    var $selected = param.$selected;
    return $selected ? "var(--active-text-color)" : "rgba(0, 0, 0, 0.7)";
}, function(param) {
    var $selected = param.$selected;
    return $selected ? "var(--active-background)" : "white";
});

// EXTERNAL MODULE: ./src/shared/svg/QuestionMark.tsx
var QuestionMark = __webpack_require__(61628);
;// CONCATENATED MODULE: ./src/shared/components/Tiles/CateringCategoryTiles.tsx

function CateringCategoryTiles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  --wrapperSize: ",
        "px;\n\n  border-radius: 8px 8px 0 0;\n  transform: scale(",
        ");\n  height: var(--wrapperSize);\n  width: var(--wrapperSize);\n  position: relative;\n  display: grid;\n  place-content: center;\n  opacity: ",
        ";\n\n  ",
        " {\n    --wrapperSize: ",
        "px;\n    width: 100%;\n  }\n"
    ]);
    CateringCategoryTiles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



















var DEFAULT_IMAGE_SIZE = {
    SM: 54,
    MD: 84
};
var IMAGE_WRAPPER_SIZE = {
    SM: 70,
    MD: 124
};
var CateringCategoryTiles = function(param) {
    var onSelect = param.onSelect, selected = param.selected, _variant = param.variant, variant = _variant === void 0 ? "primary" : _variant, items = param.items;
    var t = (0,useTranslation/* useTranslation */.$)("common").t;
    var cateringCategories = useCateringCategories(items);
    var smUp = (0,useBreakpoints/* useBreakpointUp */._)("sm");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TilesWrapper, {
        children: [
            cateringCategories.map(function(param) {
                var src = param.src, text = param.text, scale = param.scale, id = param.id;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tile, {
                    $variant: variant,
                    $selected: selected ? selected.includes(id) : false,
                    id: "tile__catering_category--".concat(id),
                    onClick: function(e) {
                        e.currentTarget.blur();
                        onSelect(id);
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageWrapper, {
                            $scale: scale,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                alt: "",
                                width: smUp ? DEFAULT_IMAGE_SIZE.MD : DEFAULT_IMAGE_SIZE.SM,
                                height: smUp ? DEFAULT_IMAGE_SIZE.MD : DEFAULT_IMAGE_SIZE.SM,
                                src: src,
                                objectFit: "cover"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TileTypography, {
                            children: text
                        })
                    ]
                }, id);
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tile, {
                $variant: variant,
                onClick: function(e) {
                    e.currentTarget.blur();
                    onSelect("other");
                },
                $selected: selected ? selected.includes("other") : false,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageWrapper, {
                        opacity: 0.4,
                        fontSize: {
                            xs: 28,
                            sm: 84
                        },
                        pt: {
                            xs: 2,
                            sm: 0
                        },
                        pb: {
                            xs: 1,
                            sm: 0
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestionMark/* default */.Z, {
                            height: "1em"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TileTypography, {
                        children: t("labels.notSure")
                    })
                ]
            })
        ]
    });
};
var ImageWrapper = (0,styled_components_browser_esm["default"])(esm.Box)(CateringCategoryTiles_templateObject(), IMAGE_WRAPPER_SIZE.SM, function(param) {
    var $scale = param.$scale;
    return $scale || 1;
}, function(param) {
    var opacity = param.opacity;
    return opacity || 1;
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("sm");
}, IMAGE_WRAPPER_SIZE.MD);
function useCateringCategories(items) {
    var t = (0,useTranslation/* useTranslation */.$)("common").t;
    var allCategories = [
        {
            id: "fingerfood",
            src: fingerfood,
            text: t("occasion.fingerfood")
        },
        {
            id: "buffet",
            src: buffet,
            text: t("occasion.buffet")
        },
        {
            id: "street_food",
            src: tacos,
            text: t("occasion.street_food"),
            scale: 1.15
        },
        {
            id: "business_lunch",
            src: lunch,
            text: t("occasion.business_lunch")
        },
        {
            id: "christmas",
            src: christmas,
            text: t("occasion.christmas"),
            scale: 1.1
        },
        {
            id: "bbq",
            src: bbq,
            text: t("occasion.bbq")
        },
        {
            id: "breakfast",
            src: breakfast,
            text: t("occasion.breakfast")
        },
        {
            id: "cakes_and_sweets",
            src: cake,
            text: t("occasion.cakes_and_sweets")
        },
        {
            id: "fine_dining",
            src: dinner,
            text: t("occasion.fine_dining_short")
        },
        {
            id: "drinks",
            src: drinks,
            text: t("occasion.drinks_short")
        }, 
    ];
    var preFilteredCategories = allCategories.filter(function(param) {
        var id = param.id;
        return id !== "bbq";
    }); // Remove seasonal entries
    if (items) {
        return preFilteredCategories.filter(function(category) {
            return items.includes(category.id);
        });
    }
    return preFilteredCategories;
}
/* harmony default export */ var Tiles_CateringCategoryTiles = (CateringCategoryTiles);

// EXTERNAL MODULE: ./src/shared/svg/cities/Berlin.tsx
var Berlin = __webpack_require__(7489);
// EXTERNAL MODULE: ./src/shared/svg/cities/Cologne.tsx
var Cologne = __webpack_require__(30947);
// EXTERNAL MODULE: ./src/shared/svg/cities/Dusseldorf.tsx
var Dusseldorf = __webpack_require__(84786);
// EXTERNAL MODULE: ./src/shared/svg/cities/FrankfurtMain.tsx
var FrankfurtMain = __webpack_require__(16707);
// EXTERNAL MODULE: ./src/shared/svg/cities/Hamburg.tsx
var Hamburg = __webpack_require__(91689);
// EXTERNAL MODULE: ./src/shared/svg/cities/Munich.tsx
var Munich = __webpack_require__(38595);
// EXTERNAL MODULE: ./src/shared/svg/cities/Other.tsx
var Other = __webpack_require__(98839);
// EXTERNAL MODULE: ./src/shared/svg/cities/Stuttgart.tsx
var Stuttgart = __webpack_require__(61737);
;// CONCATENATED MODULE: ./src/shared/svg/cities/index.tsx









;// CONCATENATED MODULE: ./src/shared/components/Tiles/CityTiles.tsx

function CityTiles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        " {\n    flex-grow: 1;\n  }\n  min-width: 50px;\n  display: grid;\n  place-content: center;\n"
    ]);
    CityTiles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var tileIcons = [
    createIconEntry("berlin", Berlin/* default */.Z),
    createIconEntry("muenchen", Munich/* default */.Z),
    createIconEntry("frankfurt-am-main", FrankfurtMain/* default */.Z, "common:cities.frankfurt-am-main-short"),
    createIconEntry("hamburg", Hamburg/* default */.Z),
    createIconEntry("duesseldorf", Dusseldorf/* default */.Z),
    createIconEntry("koeln", Cologne/* default */.Z),
    createIconEntry("stuttgart", Stuttgart/* default */.Z),
    createIconEntry("other", Other/* default */.Z, "common:labels.other"), 
];
var CityTiles = function(param) {
    var onSelect = param.onSelect, selected = param.selected, _variant = param.variant, variant = _variant === void 0 ? "primary" : _variant, _size = param.size, size = _size === void 0 ? "md" : _size;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TilesWrapper, {
        $size: size,
        children: tileIcons.map(function(param) {
            var id = param.id, Icon = param.Icon, translationKey = param.translationKey;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tile, {
                $variant: variant,
                $selected: selected === id,
                $height: size === "sm" ? "110px" : undefined,
                id: "tile__city--".concat(id),
                onClick: function(e) {
                    e.currentTarget.blur();
                    onSelect(id);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IconWrapper, {
                        fontSize: {
                            xs: id === "other" ? 30 : 50,
                            sm: 73
                        },
                        my: {
                            xs: id === "other" && 1,
                            sm: 0
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                            height: size === "sm" ? "0.6em" : "1em"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TileTypography, {
                        children: t(translationKey)
                    })
                ]
            }, id);
        })
    });
};
var IconWrapper = (0,styled_components_browser_esm["default"])(esm.Box)(CityTiles_templateObject(), function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("sm");
});
/* harmony default export */ var Tiles_CityTiles = (CityTiles);
function createIconEntry(id, Icon, translationKey) {
    return {
        id: id,
        Icon: Icon,
        translationKey: translationKey || "common:cities.".concat(id)
    };
}

// EXTERNAL MODULE: ./src/system/components/Container.tsx
var Container = __webpack_require__(10758);
;// CONCATENATED MODULE: ./src/shared/components/EmbeddedFunnel/EmbeddedQuestion.tsx


function EmbeddedQuestion_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: white;\n  border-radius: 8px;\n  padding: 1px 16px;\n  width: 100%;\n  color: black;\n"
    ]);
    EmbeddedQuestion_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


















var MAX_WIDTH_OF_WHITE_WRAPPER = 826;
var defaultStepTitleMapping = {
    catering_categories: "qualification:embeddedFunnel.cateringCategories.title",
    city: "qualification:embeddedFunnel.city.title",
    dietary_restrictions: "qualification:embeddedFunnel.dietaryRestrictions.title",
    event_date: "qualification:embeddedFunnel.eventDate.title",
    people_count_and_budget: "qualification:embeddedFunnel.budgetAndPeople.title",
    customer_tier: "qualification:customerTier.title",
    rare_customer_tier: "qualification:rareCustomerTier.title"
};
var EmbeddedQuestion = function(param) {
    var step = param.step, highlightColor = param.highlightColor, slides = param.slides, renderTitle = param.renderTitle, ratings = param.ratings, _titleTranslationKeys = param.titleTranslationKeys, titleTranslationKeys = _titleTranslationKeys === void 0 ? defaultStepTitleMapping : _titleTranslationKeys, _LayoutComponent = param.LayoutComponent, LayoutComponent = _LayoutComponent === void 0 ? EmbeddedQuestionLayout/* default */.Z : _LayoutComponent;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var ref = (0,context/* useQualification */._8)(), state = ref.state, actions = ref.actions, answerOf = ref.answerOf;
    var selectedMenu = "qualification" in state ? state.qualification.selectedMenu : null;
    var getTitleContent = (0,react.useCallback)(function(title) {
        return renderTitle ? renderTitle(title) : title;
    }, []);
    var title = t(titleTranslationKeys[step.id]);
    switch(step.id){
        case steps/* steps.city.id */.S6.city.id:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(LayoutComponent, {
                title: getTitleContent(title),
                ratings: ratings,
                content: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                    size: "sm",
                    disableGutters: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tiles_CityTiles, {
                        size: selectedMenu ? "sm" : "md",
                        variant: highlightColor,
                        selected: answerOf("city"),
                        onSelect: function(city) {
                            actions.answerQuestion("city", city);
                            actions.nextStep();
                        }
                    })
                }),
                side: selectedMenu && /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectedMenu, (0,_object_spread/* default */.Z)({}, selectedMenu))
            });
        case steps/* steps.cateringCategories.id */.S6.cateringCategories.id:
            {
                var ref1;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(LayoutComponent, {
                    wrapper: (slides === null || slides === void 0 ? void 0 : (ref1 = slides.category) === null || ref1 === void 0 ? void 0 : ref1.whiteWrapper) ? "white" : "transparent",
                    title: getTitleContent(title),
                    ratings: ratings,
                    subtitle: t("qualification:embeddedFunnel.cateringCategories.subtitle"),
                    content: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tiles_CateringCategoryTiles, {
                        variant: highlightColor,
                        selected: answerOf(questions/* questions.cateringCategories.id */.X.cateringCategories.id) || [],
                        onSelect: function(category) {
                            return actions.answerQuestion(questions/* questions.cateringCategories.id */.X.cateringCategories.id, category);
                        }
                    }),
                    side: selectedMenu && /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectedMenu, (0,_object_spread/* default */.Z)({}, selectedMenu))
                });
            }
        case steps/* steps.dietaryRestriction.id */.S6.dietaryRestriction.id:
            var ref2;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(LayoutComponent, {
                wrapper: (slides === null || slides === void 0 ? void 0 : (ref2 = slides.dietaryRestriction) === null || ref2 === void 0 ? void 0 : ref2.whiteWrapper) ? "white" : "transparent",
                ratings: ratings,
                title: getTitleContent(title),
                subtitle: t("qualification:embeddedFunnel.dietaryRestrictions.subtitle"),
                content: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                    size: MAX_WIDTH_OF_WHITE_WRAPPER,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WhiteWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                            pt: 2,
                            mb: -2,
                            pl: 2,
                            pr: 2,
                            pb: 2,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DietaryDistribution/* default */.Z, {})
                        })
                    })
                }),
                side: selectedMenu && /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectedMenu, (0,_object_spread/* default */.Z)({}, selectedMenu))
            });
        case steps/* steps.eventDateAndLeadType.id */.S6.eventDateAndLeadType.id:
            {
                var ref3;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(LayoutComponent, {
                    wrapper: (slides === null || slides === void 0 ? void 0 : (ref3 = slides.dateAndLead) === null || ref3 === void 0 ? void 0 : ref3.whiteWrapper) ? "white" : "transparent",
                    ratings: ratings,
                    title: getTitleContent(title),
                    content: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                        size: MAX_WIDTH_OF_WHITE_WRAPPER,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WhiteWrapper, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                                py: 4,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DatePicker_DatePickerEmbedded, {})
                            })
                        })
                    }),
                    side: selectedMenu && /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectedMenu, (0,_object_spread/* default */.Z)({}, selectedMenu))
                });
            }
        case steps/* steps.budgetAndPeopleCount.id */.S6.budgetAndPeopleCount.id:
            var ref4;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(LayoutComponent, {
                wrapper: (slides === null || slides === void 0 ? void 0 : (ref4 = slides.budgetAndPeople) === null || ref4 === void 0 ? void 0 : ref4.whiteWrapper) ? "white" : "transparent",
                ratings: ratings,
                title: getTitleContent(title),
                content: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                    size: MAX_WIDTH_OF_WHITE_WRAPPER,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WhiteWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                            py: 4,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BudgetQuestionWithPeopleCount/* default */.Z, {})
                        })
                    })
                }),
                side: selectedMenu && /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectedMenu, (0,_object_spread/* default */.Z)({}, selectedMenu))
            });
        case steps/* steps.customerTier.id */.S6.customerTier.id:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(EmbeddedCustomerTier, {
                ratings: ratings,
                slides: slides,
                LayoutComponent: LayoutComponent
            });
        case steps/* steps.rareCustomerTierStep.id */.S6.rareCustomerTierStep.id:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomerTierRare, {
                ratings: ratings,
                slides: slides,
                LayoutComponent: LayoutComponent
            });
        default:
            {
                var _exhaustiveCheck = step.id;
                return null;
            }
    }
};
var WhiteWrapper = styled_components_browser_esm["default"].div(EmbeddedQuestion_templateObject());
/* harmony default export */ var EmbeddedFunnel_EmbeddedQuestion = (EmbeddedQuestion);


/***/ }),

/***/ 11156:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ EmbeddedFunnel_EmbeddedQuestionLayout; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@heycater/design-system/dist/esm/index.js + 12 modules
var esm = __webpack_require__(95197);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(57833);
// EXTERNAL MODULE: ./src/qualification/context/index.tsx + 11 modules
var context = __webpack_require__(85643);
// EXTERNAL MODULE: ./src/qualification/context/model.ts
var model = __webpack_require__(91538);
// EXTERNAL MODULE: ./src/qualification/hooks/useBreakpoints.ts
var useBreakpoints = __webpack_require__(19916);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js
var useTranslation = __webpack_require__(26793);
// EXTERNAL MODULE: ./src/lib/ablyft/index.ts
var ablyft = __webpack_require__(49423);
// EXTERNAL MODULE: ./src/qualification/schema/steps/index.ts
var schema_steps = __webpack_require__(82546);
// EXTERNAL MODULE: ./src/static_pages/home/components/Hero/ProgressIndicator.tsx
var ProgressIndicator = __webpack_require__(41232);
// EXTERNAL MODULE: ./src/system/components/Container.tsx
var Container = __webpack_require__(10758);
;// CONCATENATED MODULE: ./src/shared/components/EmbeddedFunnel/EmbeddedQuestionControls.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 24px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  gap: ",
        "px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}











var EmbeddedQuestionControls = function(param) {
    var onBackground = param.onBackground;
    var ref = (0,context/* useQualification */._8)(), state = ref.state, actions = ref.actions, canContinue = ref.canContinue;
    var toPrevStep = (0,react.useCallback)(function() {
        actions.prevStep();
    }, []);
    var t = (0,useTranslation/* useTranslation */.$)().t;
    if (state.status !== model/* QUALIFICATION_STATUS.answered */.w.answered && state.status !== model/* QUALIFICATION_STATUS.answering */.w.answering && state.status !== model/* QUALIFICATION_STATUS.qualifiedForRequest */.w.qualifiedForRequest) {
        return null;
    }
    var step = state.status === model/* QUALIFICATION_STATUS.answering */.w.answering ? state.qualification.step : null;
    var steps = state.qualification.steps;
    var stepIndex = step ? steps.findIndex(function(param) {
        var id = param.id;
        return id === step.id;
    }) : -1;
    var prevStep = steps[stepIndex - 1];
    var isLastStep = Boolean(step && stepIndex === steps.length - 1);
    var enabledSteps = state.qualification.steps.filter(function(q) {
        return !q.disabled;
    });
    var hideNextBtn = function() {
        if (state.status !== "answering") return false;
        var customerTierABCExperiment = (0,ablyft/* isVariationActive */.s_)(ablyft/* EXPERIMENT.customerTierABC.variations.variationB */.Op.customerTierABC.variations.variationB) || (0,ablyft/* isVariationActive */.s_)(ablyft/* EXPERIMENT.customerTierABC.variations.variationC */.Op.customerTierABC.variations.variationC);
        if (customerTierABCExperiment && state.qualification.step.id === schema_steps/* steps.rareCustomerTierStep.id */.S6.rareCustomerTierStep.id) return true;
        return false;
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
            size: "sm",
            display: "flex",
            flexDirection: "column",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                    display: {
                        xs: "none",
                        sm: "block"
                    },
                    visibility: state.status === model/* QUALIFICATION_STATUS.answered */.w.answered ? "hidden" : "visible",
                    mb: {
                        xs: 2
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProgressIndicator/* default */.Z, {
                        currentStep: state.status === model/* QUALIFICATION_STATUS.answering */.w.answering ? state.qualification.stepIndex + 1 : enabledSteps.length,
                        stepCount: enabledSteps.length
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonsWrapper, {
                    visibility: state.status === model/* QUALIFICATION_STATUS.answered */.w.answered ? "hidden" : "visible",
                    children: [
                        prevStep && !prevStep.disabled && /*#__PURE__*/ (0,jsx_runtime.jsx)(EmbeddedButton, {
                            id: "embedded-funnel__prev-btn",
                            variant: onBackground === "dark" ? "tertiary" : "secondary",
                            rounded: true,
                            onClick: toPrevStep,
                            children: t("common:labels.back")
                        }),
                        hideNextBtn ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EmbeddedButton, {
                                variant: "primary",
                                type: "submit",
                                id: "embedded-funnel__next-btn",
                                disabled: !canContinue,
                                rounded: true,
                                children: isLastStep ? t("qualification:lastQuestionCTAShort") : t("common:labels.next")
                            })
                        })
                    ]
                })
            ]
        })
    });
};
var EmbeddedButton = (0,styled_components_browser_esm["default"])(esm.Button)(_templateObject());
var ButtonsWrapper = (0,styled_components_browser_esm["default"])(esm.Box)(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.spacing(2);
});
/* harmony default export */ var EmbeddedFunnel_EmbeddedQuestionControls = (EmbeddedQuestionControls);

// EXTERNAL MODULE: ./src/shared/components/EmbeddedFunnel/SelectedAnswers.tsx
var SelectedAnswers = __webpack_require__(62295);
;// CONCATENATED MODULE: ./src/shared/components/EmbeddedFunnel/EmbeddedQuestionLayout.tsx




function EmbeddedQuestionLayout_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 8px;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  padding: ",
        "px;\n  padding-bottom: ",
        "px;\n\n  ",
        " {\n    padding: ",
        "px;\n  }\n\n  ",
        " {\n    padding: ",
        "px;\n  }\n"
    ]);
    EmbeddedQuestionLayout_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function EmbeddedQuestionLayout_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  gap: 1rem;\n  ",
        " {\n    gap: 0;\n  }\n"
    ]);
    EmbeddedQuestionLayout_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: var(--embedded-text-color, inherit);\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 600;\n  font-size: 16px;\n  white-space: pre-line;\n  line-height: 150%;\n\n  ",
        " {\n    font-size: 18px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}










// Minimal height, that avoids height changes between questions.
var MIN_HEIGHT_OVER_MD = "670px";
var EmbeddedQuestionLayout = function(_param) {
    var title = _param.title, subtitle = _param.subtitle, content = _param.content, _containerSize = _param.containerSize, containerSize = _containerSize === void 0 ? "sm" : _containerSize, disableGutters = _param.disableGutters, _answerContainerSize = _param.answerContainerSize, answerContainerSize = _answerContainerSize === void 0 ? 826 : _answerContainerSize, side = _param.side, wrapper = _param.wrapper, boxProps = (0,_object_without_properties/* default */.Z)(_param, [
        "title",
        "subtitle",
        "content",
        "containerSize",
        "disableGutters",
        "answerContainerSize",
        "side",
        "wrapper"
    ]);
    var state = (0,context/* useQualification */._8)().state;
    var isMobile = (0,useBreakpoints/* useBreakpointDown */.a)("sm");
    if (state.status !== model/* QUALIFICATION_STATUS.answered */.w.answered && state.status !== model/* QUALIFICATION_STATUS.answering */.w.answering && state.status !== model/* QUALIFICATION_STATUS.qualifiedForRequest */.w.qualifiedForRequest) {
        return null;
    }
    var step = state.status === model/* QUALIFICATION_STATUS.answering */.w.answering ? state.qualification.step : null;
    var steps = state.qualification.steps;
    var stepIndex = step ? steps.findIndex(function(param) {
        var id = param.id;
        return id === step.id;
    }) : -1;
    var showSelectedAnswerPills = state.status === model/* QUALIFICATION_STATUS.answering */.w.answering && stepIndex > 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        size: containerSize,
        disableGutters: disableGutters
    }, boxProps), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
            bgcolor: wrapper === "white" ? "white" : "transparent",
            minHeight: {
                xs: 0,
                md: MIN_HEIGHT_OVER_MD
            },
            display: "flex",
            width: "100%",
            color: "rgba(0,0,0,0.8)",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "flex-start",
            position: isMobile ? "inherit" : "relative",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(WrapperBox, {
                    position: isMobile ? "inherit" : "absolute",
                    width: "100%",
                    flexGrow: 1,
                    display: "flex",
                    flexDirection: {
                        xs: "column",
                        md: "row"
                    },
                    mb: 4,
                    alignItems: {
                        xs: "center",
                        md: "flex-start"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                            flexGrow: 0,
                            width: {
                                xs: "100%",
                                md: "min-content"
                            },
                            maxWidth: "500px",
                            children: side
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Box, {
                            flexGrow: 1,
                            display: "flex",
                            flexDirection: "column",
                            alignSelf: "stretch",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(TextWrapper, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                                            textAlign: "center",
                                            mb: 2,
                                            maxWidth: 550,
                                            mx: "auto",
                                            children: typeof title === "string" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Subtitle, {
                                                variant: "subtitle2",
                                                children: [
                                                    title,
                                                    "\xa0"
                                                ]
                                            }) : title
                                        }),
                                        subtitle && /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Box, {
                                            as: "p",
                                            textAlign: "center",
                                            children: [
                                                subtitle,
                                                "\xa0"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                                    my: "auto",
                                    children: content
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                                    mt: 2,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EmbeddedFunnel_EmbeddedQuestionControls, {
                                        onBackground: "light"
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                    mt: "auto",
                    size: answerContainerSize,
                    disableGutters: disableGutters,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                        bgcolor: "white",
                        borderRadius: {
                            xs: 0,
                            sm: 8
                        },
                        visibility: showSelectedAnswerPills ? "visible" : "hidden",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectedAnswers/* default */.Z, {
                            currentStep: step || steps[1]
                        })
                    })
                })
            ]
        })
    }));
};
var Wrapper = (0,styled_components_browser_esm["default"])(esm.Box)(EmbeddedQuestionLayout_templateObject(), function(param) {
    var theme = param.theme;
    return theme.spacing(1);
}, function(param) {
    var theme = param.theme;
    return theme.spacing(2);
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("sm");
}, function(param) {
    var theme = param.theme;
    return theme.spacing(3);
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("md");
}, function(param) {
    var theme = param.theme;
    return theme.spacing(4);
});
var WrapperBox = (0,styled_components_browser_esm["default"])(esm.Box)(EmbeddedQuestionLayout_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("sm");
});
var TextWrapper = styled_components_browser_esm["default"].div(_templateObject2());
var Subtitle = (0,styled_components_browser_esm["default"])(esm.Typography)(_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("md");
});
/* harmony default export */ var EmbeddedFunnel_EmbeddedQuestionLayout = (EmbeddedQuestionLayout);


/***/ }),

/***/ 61654:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ EmbeddedFunnel_LoadingIndicator; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@heycater/design-system/dist/esm/index.js + 12 modules
var esm = __webpack_require__(95197);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js
var useTranslation = __webpack_require__(26793);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(57833);
// EXTERNAL MODULE: ./src/qualification/hooks/useQualifyUser.ts + 2 modules
var useQualifyUser = __webpack_require__(55351);
;// CONCATENATED MODULE: ./src/shared/components/EmbeddedFunnel/CircularLoader.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  animation-name: rotate;\n  animation-duration: 2.3s;\n  width: auto;\n  display: inline-block;\n  animation-iteration-count: infinite;\n  animation-timing-function: linear;\n\n  height: 200px;\n  width: 200px;\n\n  @keyframes rotate {\n    from {\n      transform: rotate(-360deg);\n    }\n    to {\n      transform: rotate(360deg);\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var CircularLoader = function(param) {
    var variant = param.variant;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularAnimation, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "201",
            height: "200",
            viewBox: "0 0 201 200",
            fill: "none",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M200.5 100C200.5 155.228 155.728 200 100.5 200C45.2715 200 0.5 155.228 0.5 100C0.5 44.7715 45.2715 0 100.5 0C155.728 0 200.5 44.7715 200.5 100ZM28.1509 100C28.1509 139.957 60.5427 172.349 100.5 172.349C140.457 172.349 172.849 139.957 172.849 100C172.849 60.0427 140.457 27.6509 100.5 27.6509C60.5427 27.6509 28.1509 60.0427 28.1509 100Z",
                    fill: variant === "light" ? "white" : "#9CBA6C",
                    fillOpacity: "0.2"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M200.5 100C200.5 86.8678 197.913 73.8642 192.888 61.7317C187.862 49.5991 180.497 38.5752 171.211 29.2893C161.925 20.0035 150.901 12.6375 138.768 7.61204C126.636 2.58657 113.632 -2.1395e-06 100.5 0V27.6509C110.001 27.6509 119.409 29.5222 128.187 33.1581C136.965 36.794 144.94 42.1232 151.659 48.8414C158.377 55.5597 163.706 63.5354 167.342 72.3132C170.978 81.091 172.849 90.499 172.849 100H200.5Z",
                    fill: variant === "light" ? "white" : "#9CBA6C"
                })
            ]
        })
    });
};
var CircularAnimation = styled_components_browser_esm["default"].div(_templateObject());
/* harmony default export */ var EmbeddedFunnel_CircularLoader = (CircularLoader);

// EXTERNAL MODULE: ./src/shared/components/EmbeddedFunnel/EmbeddedQuestionLayout.tsx + 1 modules
var EmbeddedQuestionLayout = __webpack_require__(11156);
;// CONCATENATED MODULE: ./src/shared/components/EmbeddedFunnel/LoadingIndicator.tsx

function LoadingIndicator_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: var(--embedded-text-color, inherit);\n"
    ]);
    LoadingIndicator_templateObject = function _templateObject() {
        return data;
    };
    return data;
}








var LoadingIndicator = function(param) {
    var variant = param.variant;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    (0,useQualifyUser/* useQualifyUser */.yk)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(EmbeddedQuestionLayout/* default */.Z, {
        wrapper: "transparent",
        content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(WrapperBox, {
            textAlign: "center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(EmbeddedFunnel_CircularLoader, {
                    variant: variant
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Typography, {
                    mt: 3,
                    mb: 1,
                    children: t("qualification:findingCaterers.listItem1")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Typography, {
                    mb: 1,
                    children: t("qualification:findingCaterers.listItem2")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Typography, {
                    children: t("qualification:findingCaterers.listItem3")
                })
            ]
        })
    });
};
var WrapperBox = (0,styled_components_browser_esm["default"])(esm.Box)(LoadingIndicator_templateObject());
/* harmony default export */ var EmbeddedFunnel_LoadingIndicator = (LoadingIndicator);


/***/ }),

/***/ 62295:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export StyledPillar */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _heycater_design_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95197);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26793);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(57833);
/* harmony import */ var qualification_components_PillLabel__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(82179);
/* harmony import */ var qualification_hooks_useAnswerPills__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(45078);
/* harmony import */ var qualification_hooks_useBreakpoints__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(19916);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  gap: ",
        "rem;\n  border-radius: 2rem;\n  margin-left: 0px;\n  margin-right: 0px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-weight: 400;\n  flex-shrink: 0;\n  color: initial;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: inline-flex;\n  flex-wrap: nowrap;\n  border: none;\n  height: 2px;\n  flex-direction: row;\n  align-items: flex-start;\n  padding: ",
        ";\n  gap: ",
        "px;\n  background: #f0f0f0;\n  border-radius: 66px;\n  white-space: nowrap;\n  cursor: pointer;\n\n  transition: color 0.2s, background-color 0.2s;\n\n  :hover,\n  :active,\n  :focus {\n    background-color: ",
        ";\n    color: white;\n  }\n\n  ",
        " {\n    padding: ",
        ";\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  overflow-x: auto;\n  overflow-y: hidden;\n  white-space: nowrap;\n  width: 100%;\n  margin-left: 8px;\n  margin-right: 8px;\n  padding-bottom: 4px;\n  padding-top: 4px;\n  scrollbar-width: thin;\n\n  ::-webkit-scrollbar {\n    height: 3px;\n  }\n  ::-webkit-scrollbar-track {\n    background: #f1f1f1;\n  }\n  ::-webkit-scrollbar-thumb {\n    background: #bec4c4;\n    border-radius: 5px;\n    overflow: hidden;\n  }\n  ::-webkit-scrollbar-thumb:hover {\n    background: #555;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}








function SelectedAnswers(param) {
    var currentStep = param.currentStep, wrap = param.wrap;
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_6__/* .useTranslation */ .$)("qualification").t;
    var isMobile = (0,qualification_hooks_useBreakpoints__WEBPACK_IMPORTED_MODULE_7__/* .useBreakpointDown */ .a)("xs");
    var scrollableBoxRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    var pills = (0,qualification_hooks_useAnswerPills__WEBPACK_IMPORTED_MODULE_5__/* .useAnswerPills */ .q)({
        display: "previous-answers"
    });
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var scrollLatestElementIntoView = function scrollLatestElementIntoView() {
            if (!scrollableBoxRef.current) {
                return;
            }
            var horizontalScrollAmount = scrollableBoxRef.current.scrollWidth;
            if (!horizontalScrollAmount) {
                return;
            }
            scrollableBoxRef.current.scroll({
                left: horizontalScrollAmount,
                behavior: "smooth"
            });
        };
        scrollLatestElementIntoView();
    }, [
        currentStep,
        scrollableBoxRef
    ]);
    if (!currentStep) return null;
    if (isMobile) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__.Box, {
            display: "flex",
            alignItems: "center",
            pt: 0.5,
            pb: 0.5,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__.Box, {
                    flexShrink: 0,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(TypographyYourSelection, {
                        pl: 2,
                        variant: "caption",
                        fontSize: 10,
                        children: t("selection.yourSelection")
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(HorrizontallyScrollableBox, {
                    ref: scrollableBoxRef,
                    display: "flex",
                    flexWrap: wrap ? "wrap" : "nowrap",
                    alignItems: "center",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(PillsWrapperBox, {
                        mx: 2,
                        display: "flex",
                        gap: 1,
                        children: pills.map(function(pill) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(qualification_components_PillLabel__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                size: "sm",
                                stepId: pill.stepId,
                                questionId: pill.questionId,
                                text: pill.text || ""
                            }, pill.questionId);
                        })
                    })
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__.Box, {
        display: "flex",
        alignItems: "center",
        pt: 0.5,
        pb: 0.5,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__.Box, {
                flexShrink: 0,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(TypographyYourSelection, {
                    variant: "caption",
                    pl: 2,
                    pr: 1.5,
                    fontSize: 10,
                    children: t("selection.yourSelection")
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(HorrizontallyScrollableBox, {
                display: "flex",
                alignItems: "center",
                flexWrap: wrap ? "wrap" : "nowrap",
                ref: scrollableBoxRef,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(PillsWrapperBox, {
                    display: "flex",
                    gap: 0.75,
                    children: pills.map(function(pill) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(qualification_components_PillLabel__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            size: "sm",
                            stepId: pill.stepId,
                            questionId: pill.questionId,
                            text: pill.text || ""
                        }, pill.questionId);
                    })
                })
            })
        ]
    });
}
var PillsWrapperBox = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__["default"])(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__.Box)(_templateObject(), function(props) {
    return props.gap || 1;
});
var TypographyYourSelection = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__["default"])(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__.Typography)(_templateObject1());
var StyledPillar = styled_components__WEBPACK_IMPORTED_MODULE_8__["default"].button(_templateObject2(), function(props) {
    return props.theme.spacing(1, 2);
}, function(props) {
    return props.theme.spacing(0.5);
}, function(props) {
    return props.theme.palette.grey.secondary;
}, function(props) {
    return props.theme.breakpoints.down("xs");
}, function(props) {
    return props.theme.spacing(0.5, 1);
});
var HorrizontallyScrollableBox = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__["default"])(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__.Box)(_templateObject3());
/* harmony default export */ __webpack_exports__["Z"] = (SelectedAnswers);


/***/ }),

/***/ 61628:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);




var QuestionMark = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        width: "26",
        height: "41",
        viewBox: "0 0 26 41",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M13.0859 0C16.9893 0 20.1084 1.02181 22.4431 3.06542C24.8144 5.10904 26 7.99199 26 11.7143C26 15.1446 24.8691 17.8269 22.6073 19.761C20.382 21.6587 17.4271 22.6257 13.7425 22.6622L13.4689 26.7677H5.26076L4.98715 16.5861H8.27041C11.0794 16.5861 13.2135 16.2394 14.6728 15.5461C16.1685 14.8527 16.9163 13.5937 16.9163 11.769C16.9163 10.4918 16.5698 9.48821 15.8766 8.75835C15.1835 8.02848 14.2168 7.66355 12.9764 7.66355C11.6631 7.66355 10.6417 8.04673 9.91204 8.81308C9.18243 9.54295 8.81762 10.5465 8.81762 11.8238H0.00754772C-0.0654136 9.59769 0.390594 7.59057 1.37557 5.8024C2.39703 4.01424 3.89274 2.60926 5.86269 1.58745C7.86912 0.529151 10.2768 0 13.0859 0ZM9.47427 41C7.83264 41 6.48286 40.5256 5.42492 39.5768C4.40346 38.5915 3.89274 37.3872 3.89274 35.964C3.89274 34.5042 4.40346 33.2817 5.42492 32.2964C6.48286 31.3111 7.83264 30.8184 9.47427 30.8184C11.0794 30.8184 12.3927 31.3111 13.4142 32.2964C14.4721 33.2817 15.0011 34.5042 15.0011 35.964C15.0011 37.3872 14.4721 38.5915 13.4142 39.5768C12.3927 40.5256 11.0794 41 9.47427 41Z",
            fill: "#3C4340"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (QuestionMark);


/***/ }),

/***/ 41232:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _heycater_design_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95197);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26793);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(57833);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: var(--embedded-text-color, inherit);\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  justify-content: center;\n  gap: ",
        "px;\n\n  ",
        " {\n    flex-direction: row;\n    gap: ",
        "px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 10px;\n  background: ",
        ";\n  position: relative;\n  max-width: 380px;\n  width: 100%;\n  border-radius: 10px;\n  overflow: hidden;\n\n  :before {\n    content: '';\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    background: ",
        ";\n    transition: width 250ms ease;\n    width: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





var ProgressIndicator = function(param) {
    var stepCount = param.stepCount, currentStep = param.currentStep;
    var percent = currentStep / stepCount * 100;
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_4__/* .useTranslation */ .$)().t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__.Typography, {
                fontWeight: 600,
                fontSize: 14,
                lineHeight: "150%",
                children: [
                    currentStep,
                    "/",
                    stepCount,
                    " ",
                    t("qualification:steps")
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ProgressBar, {
                percent: percent
            })
        ]
    });
};
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].div(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.spacing(1);
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("sm");
}, function(param) {
    var theme = param.theme;
    return theme.spacing(2);
});
var ProgressBar = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].div(_templateObject1(), function(props) {
    return props.theme.palette.grey[100];
}, function(param) {
    var theme = param.theme;
    return theme.palette.primary.main;
}, function(param) {
    var percent = param.percent;
    return percent ? "".concat(percent, "%") : "0";
});
/* harmony default export */ __webpack_exports__["Z"] = (ProgressIndicator);


/***/ })

}]);